import Vue from 'vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import FloatingVue from 'floating-vue'
import router from './router'
import store from './store'
import Router from './component/Router.vue'
import { closeSpashscreen } from '../util'
import logger from '../logger'

import './_asset/scss/app.scss'
import 'swiper/dist/css/swiper.css'
import 'floating-vue/dist/style.css'

/* import the fontawesome core */
import { library } from '@fortawesome/fontawesome-svg-core'

/* import specific icons */
import { faPix } from '@fortawesome/free-brands-svg-icons'
import { faCopy } from '@fortawesome/free-regular-svg-icons'
/* import font awesome icon component */
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import VueImg from 'v-img'
const vueImgConfig = {
  // Use `alt` attribute as gallery slide title
  altAsTitle: false,
  // Display 'download' button near 'close' that opens source image in new tab
  sourceButton: false,
  // Event listener to open gallery will be applied to <img> element
  openOn: 'click',
  // Show thumbnails for all groups with more than 1 image
  thumbnails: true
}
Vue.use(VueImg, vueImgConfig)

/* add icons to the library */
library.add(faPix)
library.add(faCopy)

/* add font awesome icon component */
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.use(VueAwesomeSwiper)
FloatingVue.options.themes.tooltip.triggers = ['hover', 'focus', 'touch', 'click']
Vue.use(FloatingVue)
export const render = (user = null) => {
  new Vue({
    router,
    store,
    render: h => h(Router),
    beforeCreate () {
      loadAPIs()
      if (user && user !== 'redirect') {
        document.body.style.backgroundColor = '#f2f2f2'
      } else {
        document.body.style.backgroundColor = '#1e1e1e'
      }
      this.$store.commit('user', user === 'redirect' ? null : user)
      if (user === 'redirect') this.$router.push('/')
    },
    mounted () {
      closeSpashscreen(this)
      this.$analytics.event('access')
    }
  }).$mount('#app')
}

// Error handler
Vue.config.errorHandler = (err, vm, info) => {
  // err.component = `component name: ${vm.$options.name}, route: ${vm.$route.fullPath}`
  logger.error(err, vm)
}

// Warning handler
Vue.config.warnHandler = (msg, vm, trace) => {
  logger.warn(msg, vm)
}

const loadAPIs = () => {
  if (process.env.CORDOVA_PLATFORM) { // CORDOVA ---------------------------------
    document.addEventListener('deviceready', () => {
      // Google Analytics
      // window.cordova.plugins.firebase.analytics.setCurrentScreen('shows')
      router.beforeEach((to, from, next) => {
        // window.cordova.plugins.firebase.analytics.setCurrentScreen(to.name)
        next()
      })
      // Zoom
      window.cordova.plugins.ZoomControl.ZoomControl('true')
      window.cordova.plugins.ZoomControl.setBuiltInZoomControls('true')
      window.cordova.plugins.ZoomControl.setDisplayZoomControls('false')
      window.cordova.plugins.ZoomControl.setUseWideViewPort('true')
      // One Signal
      /*
      if (process.env.NODE_ENV !== 'production') {
        window.plugins.OneSignal.setLogLevel({ logLevel: 3, visualLevel: 3 })
      }
      */
      // const notificationCallback = (jsonData) => {
      // console.log('notificationOpenedCallback: ' + JSON.stringify(jsonData))
      // }
      // window.plugins.OneSignal.setRequiresUserPrivacyConsent(true)
      /*
      window.plugins.OneSignal
        .startInit(process.env.VUE_APP_ONESIGNAL)
        .handleNotificationOpened(notificationCallback)
        .endInit()
      */
    }, false)
  } else { // WEB ----------------------------------------------------------------
    // Load Facebook Login
    // let js = document.getElementsByTagName('script')[0]
    // const fjs = document.getElementsByTagName('script')[0]
    /* if (!document.getElementById('facebook-jssdk')) {
      js = document.createElement('script')
      js.id = 'facebook-jssdk'
      js.src = `https://connect.facebook.net/pt_BR/sdk.js#xfbml=1&version=${process.env.VUE_APP_FACEBOOK_VERSION}&appId=${process.env.VUE_APP_FACEBOOK_APP_ID}&autoLogAppEvents=1`
      fjs.parentNode.insertBefore(js, fjs)
    }
    // Apple Sign In
    window.AppleID.auth.init({
      clientId: process.env.VUE_APP_APPLE_CLIENT_ID,
      scope: 'name email',
      redirectURI: process.env.VUE_APP_APPLE_REDIRECT,
      state: 'tiketera',
      usePopup: true
    }) */
    // if (process.env.NODE_ENV === 'production') {
    // Load Google Analytics
    window.dataLayer = window.dataLayer || []
    /* window.gtag = function () {
      window.dataLayer.push(arguments)
    }
    window.gtag('js', new Date())
    window.gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS)
    router.beforeEach((to, from, next) => {
      window.gtag('config', process.env.VUE_APP_GOOGLE_ANALYTICS, { 'page_path': to.path })
      next()
    }) */
    // Load One Signal
    /*
      const OneSignal = window.OneSignal || []
      OneSignal.push(() => {
        OneSignal.init({
          appId: process.env.VUE_APP_ONESIGNAL,
          allowLocalhostAsSecureOrigin: !(process.env.NODE_ENV === 'production'),
          persistNotification: true,
          welcomeNotification: {
            disable: true
          }
        })
      })
      */
    // }
  }
}

export {
  router
}
